import { useCallback, useEffect } from 'react';

interface UseBreakPagesProps {
  containerRef: React.RefObject<HTMLElement>;
  pageHeight: number;
  margin: number; // Margin for headers, footers, or padding
}

const useBreakPages = ({
  containerRef,
  pageHeight,
  margin,
}: UseBreakPagesProps) => {
  const prepareForPrint = useCallback(() => {
    if (!containerRef.current) return;
    console.log('children', containerRef.current.children);
    const container = containerRef.current;
    const children = Array.from(
      document.querySelectorAll('.heatmap-wrapper')
    ) as HTMLElement[];
    const totalPageHeight = pageHeight - margin;

    let currentHeight = 0;

    for (const child of children) {
      // Reset any existing page breaks
      child.classList.remove('page_break_class');

      const childTop = child.offsetTop - container.offsetTop; // Distance from container's top
      const childBottom = childTop + child.offsetHeight;

      console.log('childTop', childTop);
      console.log('childBottom', childBottom);

      if (childBottom > currentHeight + totalPageHeight) {
        // Add a page_break_class class if the element overflows the current page
        child.classList.add('page_break_class');
        currentHeight = childTop; // Reset height at the start of a new page
      }
    }

    console.log(
      'page break',
      document.getElementsByClassName('page_break_class')
    );
  }, [containerRef, pageHeight, margin]);

  useEffect(() => {
    // Optional: Automatically prepare layout changes on mount or updates
    prepareForPrint();
  }, [prepareForPrint]);

  return { prepareForPrint };
};

export default useBreakPages;
